import { render, staticRenderFns } from "./ChangeMailDone.vue?vue&type=template&id=26f0afbc&scoped=true&lang=pug"
import script from "./ChangeMailDone.vue?vue&type=script&lang=js"
export * from "./ChangeMailDone.vue?vue&type=script&lang=js"
import style0 from "./ChangeMailDone.vue?vue&type=style&index=0&id=26f0afbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f0afbc",
  null
  
)

export default component.exports